module.exports = __webpack_public_path__ + "static/media/book.4b2ddf89.svg";